module.exports = __webpack_public_path__ + "img/contact_us_check.93a39bcf.svg";